import React, {useEffect, useState} from "react";
import {fetchJson} from "../fetch.js";
import * as BookPageHelpers from './helpers.js';
import * as Helpers from '../helpers.mjs';

import { useElasticData, useExtraData } from "./DataContext.js";

const BookPageClassSetOverlay = () => {
    const classSetOverlays = [
        "/assets/img/classSetOverlays/steel.png",
        "/assets/img/classSetOverlays/green.png",
        "/assets/img/classSetOverlays/aqua.png",
        "/assets/img/classSetOverlays/yellow.png",
        "/assets/img/classSetOverlays/red.png",
        "/assets/img/classSetOverlays/blue.png",
        "/assets/img/classSetOverlays/purple.png"
    ];

    const [randomClassSetOverlay, setRandomClassSetOverlay] = useState("");
    useEffect(() => {
        const randomIndex = Math.floor(Math.random() * classSetOverlays.length);
        setRandomClassSetOverlay(classSetOverlays[randomIndex]);
    },[]);

    return (
        <div className="classSetOverlay">
            <img className="classSetOverlayImage" src={randomClassSetOverlay} alt="Class set offer" />
        </div>
    );
}

const BookPageImage = () => {
    
    let { elasticData, product } = useElasticData();
    let { extraData, _source, _index, isLibraryUser } = useExtraData();

    if (!extraData) {
        return null;
    }

    const bookpageEan13 = _source.id;
    const bookpageId = _source.product_id;

    const idx = _index;

    const isLibraryUserAndNotBookPack = (isLibraryUser() && (!idx.includes("dyn_book_packs") || !_source.isbookpack));

    const [bookPackLinks, setBookPackLinks] = useState([]);
    const [coverImageSrc, setCoverImageSrc] = useState("");
    const [alternateBookImages, setAlternateBookImages] = useState([]);

    useEffect(() => {
        function setBookPageImages() {
            const imageLinks = BookPageHelpers.getBookImageLinks(bookpageEan13);

            if(Helpers.IsBooksForTopic(_source)) {
                setCoverImageSrc("/assets/img/booksForTopics.jpg");
            } else {
                setCoverImageSrc(imageLinks.cover);
            }

            setBookPackLinks([]);

            var alternateBookImageLinks = Object.entries(imageLinks).filter(i => i[0] != "cover");
            setAlternateBookImages(alternateBookImageLinks);
        }

        function setBookPackImages() {
            setCoverImageSrc("");
            setBookPackLinks([]);
            setAlternateBookImages([]);

            const isBooksForTopicsPack = (_source.origin?.replace(/\W+/g, '').toLowerCase() == "booksfortopics");

            if(isBooksForTopicsPack) {
                fetchJson("/product/getBooksForTopicsBookPackImages/"+_source.product_id).then(r => {
                    setBookPackLinks(r);
                });
            } else {
                fetchJson("/product/getBookPackImages/"+_source.product_id).then(r => {
                    setBookPackLinks(r);
                });
            }

            if (bookPackLinks.length > 1) {
                setCoverImageSrc("");
            } else if (isBooksForTopicsPack) {
                setCoverImageSrc("/assets/img/booksForTopics.jpg");
            } else if (bookPackLinks.length == 1) {
                const productImageSrc = Helpers.getProductImageLink(bookPackLinks[0].prEan13);
                setCoverImageSrc(`${productImageSrc}`);
            }
        }

        if (idx.includes("dyn_book_packs")) {
            setBookPackImages();
        } else if (!elasticData.isbookpack) {
            setBookPageImages();
        }
    }, [bookpageId]);

    useEffect(() => {
        if ($('#bookPackImages').hasClass('slick-slider')) {
            $("#bookPackImages").slick('unslick');
        }

        $('#bookPackImages').slick({
            infinite: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            autoplay: true,
            autoplaySpeed: 2000,
            arrows: false,
            draggable: true,
        });
    }, [bookPackLinks]);

    useEffect(() => {
        if ($('#alternateBookImageContainer').hasClass('slick-slider')) {
            $("#alternateBookImageContainer").slick('unslick');
        }

        $('#alternateBookImageContainer').slick({
            infinite: false,
            slidesToShow: 3,
            slidesToScroll: 1,
            arrows: false,
            dots: true,
            dotsClass: "alternateImagesPagination",
            customPaging: function(slick,index) {
                return '<span class="alternateImagesPaginationBullet" tabindex="' + index + '" role="button" aria-label="Go to slide ' + (index + 1) + '"></span>';
            }
        });
    }, [alternateBookImages]);

    return (
        <>
            <div className={`bookPageImage${(extraData.offerMinQuantity > 1) ? " classSetOffer" : ""}`}>
                {bookPackLinks.length > 1 && <div id="bookPackImages">
                    {bookPackLinks.map(b => <img className="bookPackItemImage bookImg" onError={(e) => {Helpers.handleImageError(e)}} src={BookPageHelpers.getBookImageLinks(b.prEan13).cover} />)}
                </div>}
                {bookPackLinks.length <= 1 && coverImageSrc !== "" && <>
                    <div className="image lightboxable"><img className="viewable frontcoverImage bookImg" onError={(e) => {Helpers.handleImageError(e)}} src={coverImageSrc} alt={_source.title} title={_source.title} /></div>
                    {extraData.offerMinQuantity > 1 && <BookPageClassSetOverlay />}
                </>}
                {(idx.includes("dyn_book_packs") || _source.isbookpack === 1) && <p className="bookPackDisclaimer"><em>Covers shown are representative of the contents of each pack, your selection may vary.</em></p>}
            </div>
            
            {alternateBookImages.length > 1 && <div key={bookpageEan13} id="alternateBookImageContainer" className="alternateImages">
                {/* <LoadingSpinner overlay={true} text="Checking for alternate images..." /> */}
                {alternateBookImages.map(i => {
                    const imgType = i[0];
                    const imgLink = i[1];
                    return (
                        <>
                            {imgType === "centerfold" && <div className="image lightboxable">
                                <img className="viewable centerfoldImage bookImg" onError={(e) => {Helpers.handleImageError(e)}} src={imgLink} alt="Centerfold image" title="Centerfold image" />
                            </div>}
                            {imgType === "backcover" && <div className="image lightboxable">
                                <img className="viewable backcoverImage bookImg" onError={(e) => {Helpers.handleImageError(e)}} src={imgLink} alt="Backcover image" title="Backcover image" />
                            </div>}
                            {imgType.startsWith("additional") && <div className="image lightboxable">
                                <img className="viewable additionalImage bookImg" onError={(e) => {Helpers.handleImageError(e)}} src={imgLink} alt="Additional image" title="Additional image" />
                            </div>}
                        </>
                    );
                })}
            </div>}
            {isLibraryUserAndNotBookPack && <>
                <input id="showBookSize" name="showBookSize" type="checkbox"></input>
                <label className="showBookSizeLabel" for="showBookSize"></label>
            </>}
        </>
    );
}

export default BookPageImage;